import React from 'react';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/material/styles';

interface CustomSwitcherProps extends SwitchProps {
  switcherStyles?: {
    noSelectBg?: string;
    checkedBg?: string;
    thumbColor?: string;
    switchSize?: { width: number; height: number };
    thumbSize?: { width: number; height: number };
    checkedTransform?: string;
  };
}

export const Switcher: React.FC<CustomSwitcherProps> = (props) => {
  const { switcherStyles, ...rest } = props;

  const WebSwitch = styled(Switch)(() => ({
    width: switcherStyles?.switchSize?.width ?? 34,
    height: switcherStyles?.switchSize?.height ?? 24,
    padding: 0,
    '& .MuiSwitch-switchBase': {
      padding: 0,
      margin: 3,

      '&.Mui-checked': {
        transform: switcherStyles?.checkedTransform ?? 'translateX(10px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: switcherStyles?.checkedBg ?? '#2abb7f',
          opacity: 1,
          border: 0,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      boxSizing: 'border-box',
      width: switcherStyles?.thumbSize?.width ?? 18,
      height: switcherStyles?.thumbSize?.height ?? 18,
      backgroundColor: switcherStyles?.thumbColor ?? '#fff',
    },
    '& .MuiSwitch-track': {
      borderRadius: 50,
      backgroundColor: switcherStyles?.noSelectBg ?? '#dd360c',
      opacity: 1,
    },
  }));

  return (
    <WebSwitch
      focusVisibleClassName=".Mui-focusVisible"
      disableRipple
      {...rest}
    />
  );
};
